const $inject = ['$q', '$http', 'APP_CONFIG'];

const depotSearchService = function ($q, $http, APP_CONFIG) {
  var service = {};

  service.get = get;

  function get (params) {
    let deferred = $q.defer();
    let url = APP_CONFIG.api.depotSearch;

    $http.get(url, { params: params })
      .then((response) => {

        let data = {
          carSuppliers: [],
          suppliers: {},
          supplierLocations: [],
          anySupplier: {
            supplierId: '',
            supplierLogo: 'https://az867575.vo.msecnd.net/static/blank.gif',
            supplierName: 'Any Supplier'
          }
        };

        response.data.forEach(supplier => {
          let thisSupplier = {
            supplierId: supplier.Code,
            supplierLogo: supplier.Logo,
            supplierName: supplier.Title
          };

          data.carSuppliers.push(thisSupplier);

          data.suppliers[supplier.Code] = thisSupplier;

          supplier.Depots.forEach(depot => {
            data.supplierLocations.push({
              addressLabel: depot.Address,
              addressLine: depot.Street,
              cityName: depot.City,
              cityCode: depot.CityCode,
              fullCode: depot.FullCode,
              code: depot.Code,
              latitude: depot.Latitude,
              locationCode: depot.Code,
              longtitude: depot.Longitude,
              stateCode: depot.State,
              supplierId: depot.Supplier
            });
          });
        });

        data.suppliers.ANY = data.anySupplier;

        data.carSuppliers.push(data.anySupplier);

        deferred.resolve(data);
      }).catch(err => {
        deferred.reject(err);
    });

    return deferred.promise;
  }

  return service;
};

depotSearchService.$inject = $inject;

export default depotSearchService;



// WEBPACK FOOTER //
// ./src/services/depotSearchService.js